export function PersonsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 6a4 4 0 118 0 4 4 0 01-8 0zm4-2a2 2 0 100 4 2 2 0 000-4zM7 11c-1.698 0-2.922.642-3.732 1.565-.782.89-1.12 1.971-1.227 2.81C1.92 16.332 2.709 17 3.5 17h7c.791 0 1.58-.669 1.459-1.624-.107-.84-.445-1.921-1.227-2.811C9.922 11.642 8.698 11 7 11zm2.23 2.884c.288.33.485.725.607 1.116H4.163a3.09 3.09 0 01.608-1.116C5.189 13.407 5.86 13 7 13c1.14 0 1.81.407 2.23.884zM17 16c-1.698 0-2.922.642-3.732 1.564-.782.89-1.12 1.972-1.227 2.812-.122.955.668 1.624 1.459 1.624h7c.791 0 1.58-.669 1.459-1.624-.107-.84-.445-1.922-1.227-2.812C19.922 16.642 18.698 16 17 16zm2.23 2.884c.288.33.485.725.607 1.116h-5.675a3.09 3.09 0 01.609-1.116C15.189 18.407 15.859 18 17 18c1.14 0 1.81.407 2.23.884zM17 7a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
